import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-body-card-row-template]' })
export class GridBodyCardRowTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
